import { PagedData } from "@/services/models/shared/PagedData";
import { AxiosResponse } from "axios";
import {
  InterdepartmentalTransferFilterOptions,
  InterdepartmentalTransferListItem,
  InterdepartmentalTransferNumber,
  UpdateInterdepartmentalTransfer,
  UpdateInterdepartmentalTransferNumber
} from "@/services/models/InterdepartmentalTransfer";
import BimsHttpService from "@/services/BimsHttpService";
import FileProvider from "@/utilities/providers/FileProvider";

class InterdepartmentalTransfersService {
  /**
   * @description Returns a paged list of IDTs
   */
  getIDTs(
    type: string,
    filter: InterdepartmentalTransferFilterOptions
  ): Promise<PagedData<InterdepartmentalTransferListItem>> {
    return BimsHttpService.get(`/interdepartmentaltransfers/${type}`, {
      params: filter,
    }).then((response: AxiosResponse<PagedData<InterdepartmentalTransferListItem>>) => {
      return response.data as PagedData<InterdepartmentalTransferListItem>;
    });
  }

  /**
   * @description Returns the current IDT number
   */
  getIDTNumber(id: string): Promise<InterdepartmentalTransferNumber> {
    return BimsHttpService.get(`/interdepartmentaltransfers/Number/${id}`).then((response: AxiosResponse<InterdepartmentalTransferNumber>) => {
      return response.data as InterdepartmentalTransferNumber;
    });
  }

  /**
 * @description Updates the IDT
 */
  updateIDT(idt: UpdateInterdepartmentalTransfer): Promise<any> {
    return BimsHttpService.put(`/interdepartmentaltransfers`, idt);
  }

  /**
 * @description Updates the IDT number
 */
  updateIDTNumber(data: UpdateInterdepartmentalTransferNumber): Promise<any> {
    return BimsHttpService.put(`/interdepartmentaltransfers/number`, data);
  }

  /**
   * @description Downloads the CSV export for the base account listing
   */
  public downloadIDTFrozenAndMissingAccounts(type: string): Promise<any> {
    return BimsHttpService.get(`/interdepartmentaltransfers/${type}/accounts/frozenAndMissing/report`).then(response => {
      return FileProvider.ForceFileDownload(response)
    })
  }
}

export default new InterdepartmentalTransfersService();
